import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  LivingSpaceFilterState,
  LivingSpaceRange,
} from '@immosky/types';
import { Subscription } from 'rxjs';
import {
  resetLivingSpaceFilter,
  selectLivingSpaceFilterState,
  setLivingSpaceFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-living-space-filter-dropdown',
  templateUrl: './living-space-filter-dropdown.component.html',
  styleUrls: ['./living-space-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LivingSpaceFilterDropdownComponent implements OnDestroy {
  private subscription: Subscription;

  appliedFilter!: LivingSpaceRange;
  currentFilter!: LivingSpaceRange;
  isActive = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.subscription = this.store
      .pipe(select(selectLivingSpaceFilterState))
      .subscribe((filterState: LivingSpaceFilterState) => {
        this.appliedFilter = {
          ...filterState.filter,
        };
        this.currentFilter = {
          ...filterState.filter,
        };
        this.isActive = filterState.isActive;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  select(filter: LivingSpaceRange) {
    this.currentFilter = filter;
  }

  applyChanges() {
    if (this.currentFilter) {
      this.store.dispatch(
        setLivingSpaceFilter({
          filter: this.currentFilter,
        })
      );
    }
  }

  reset() {
    this.store.dispatch(resetLivingSpaceFilter());
  }
}
